// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-card {
  width: min(1400px, calc(100% - 40px));
  margin: 28px auto;
  padding: 24px 28px;

  background: #ffffff;
  border: 1px solid #d9e2dc;
  border-left: 6px solid #277a3e;
  border-radius: 18px;

  box-shadow:
    0 1px 2px rgba(23, 33, 26, 0.05),
    0 10px 28px rgba(23, 33, 26, 0.08);

  box-sizing: border-box;
}

.summary-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;

  padding-bottom: 20px;
  margin-bottom: 20px;

  border-bottom: 1px solid #d9e2dc;
}

.summary-eyebrow {
  display: block;
  margin-bottom: 5px;

  color: #277a3e;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.summary-card-header h2 {
  margin: 0;

  color: #17211a;
  font-size: clamp(1.25rem, 2vw, 1.65rem);
  line-height: 1.2;
}

.summary-period {
  flex-shrink: 0;
  max-width: 100%;
  padding: 8px 14px;

  background: #fff8cc;
  border: 1px solid #ebd650;
  border-radius: 999px;

  color: #665700;
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;

  box-sizing: border-box;
}

/* ==========================================
   Summary content layout
========================================== */

.summary-content {
  display: grid;
  grid-template-columns:
    minmax(180px, 0.85fr)
    minmax(180px, 0.85fr)
    minmax(280px, 1.2fr)
    minmax(170px, 0.45fr);

  gap: 18px;
  align-items: stretch;
  min-width: 0;
}

/* ==========================================
   AC and DC statistic tiles
========================================== */

.summary-stat {
  display: flex;
  flex-direction: column;
  justify-content: center;

  min-width: 0;
  padding: 18px 20px;
  border-radius: 14px;

  box-sizing: border-box;
}

.summary-stat-ac {
  background: #eaf4ed;
  border: 1px solid #b7d8bf;
}

.summary-stat-dc {
  background: #fff8cc;
  border: 1px solid #ebd650;
}

.summary-stat-label {
  color: #526159;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.summary-stat strong {
  margin-top: 6px;

  color: #17211a;
  font-size: 2rem;
  line-height: 1.1;
}

.summary-stat strong span {
  color: #617067;
  font-size: 1.1rem;
  font-weight: 650;
}

.summary-stat small {
  margin-top: 6px;

  color: #617067;
  font-size: 0.8rem;
  line-height: 1.35;
}

/* ==========================================
   Compact map tile
========================================== */

.summary-map-tile {
  min-width: 0;
  overflow: hidden;

  background: #ffffff;
  border: 1px solid #c8d9ce;
  border-radius: 14px;

  box-sizing: border-box;
}

.summary-map-header {
  min-height: 66px;
  padding: 11px 13px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  background: #f7faf7;
  border-bottom: 1px solid #d9e2dc;

  box-sizing: border-box;
}

.summary-map-header > div {
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 3px;
}

.summary-map-label {
  color: #4e6255;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.summary-map-header strong {
  color: #17211a;
  font-size: 0.96rem;
  line-height: 1.25;
}

.summary-map-button {
  flex-shrink: 0;
  padding: 8px 10px;

  background: #ffffff;
  border: 1px solid #79ae88;
  border-radius: 9px;

  color: #17552a;
  font-family: inherit;
  font-size: 0.74rem;
  font-weight: 750;
  white-space: nowrap;

  cursor: pointer;

  transition:
    background 150ms ease,
    border-color 150ms ease,
    transform 150ms ease;
}

.summary-map-button:hover {
  background: #eaf4ed;
  border-color: #277a3e;
  transform: translateY(-1px);
}

.summary-map-button:focus-visible {
  outline: 3px solid rgba(39, 122, 62, 0.22);
  outline-offset: 2px;
}

.summary-map-container {
  position: relative;
  width: 100%;
  height: 170px;

  overflow: hidden;
  background: #edf2ee;
}

.summary-leaflet-map {
  width: 100%;
  height: 100%;
  z-index: 1;
}

.summary-map-empty {
  position: absolute;
  inset: 0;
  z-index: 2;

  padding: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(247, 250, 247, 0.94);
  color: #617067;
  font-size: 0.82rem;
  line-height: 1.4;
  text-align: center;
}

.summary-map-tile .leaflet-popup-content {
  min-width: 160px;
  margin: 12px 14px;
}

.summary-map-tile .leaflet-popup-content p {
  margin: 5px 0;

  font-size: 0.78rem;
  line-height: 1.35;
}

.summary-map-tile .leaflet-popup-content a {
  color: #277a3e;
  font-size: 0.78rem;
  font-weight: 700;
}

/* ==========================================
   Month navigation
========================================== */

.summary-navigation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;

  min-width: 170px;
}

.summary-button {
  width: 100%;
  min-height: 44px;
  padding: 10px 16px;

  border-radius: 10px;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;

  cursor: pointer;

  transition:
    background 150ms ease,
    border-color 150ms ease,
    color 150ms ease,
    transform 150ms ease;

  box-sizing: border-box;
}

.summary-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.summary-button-primary {
  color: #ffffff;
  background: #277a3e;
  border: 1px solid #277a3e;
}

.summary-button-primary:hover:not(:disabled) {
  background: #17552a;
  border-color: #17552a;
}

.summary-button-secondary {
  color: #17552a;
  background: #ffffff;
  border: 1px solid #9fc5a8;
}

.summary-button-secondary:hover:not(:disabled) {
  background: #eaf4ed;
  border-color: #277a3e;
}

.summary-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ==========================================
   Smaller desktop and large tablets
========================================== */

@media (max-width: 1200px) {
  .summary-content {
    grid-template-columns:
      repeat(2, minmax(0, 1fr));
  }

  .summary-map-tile {
    grid-column: 1 / -1;
  }

  .summary-map-container {
    height: 220px;
  }

  .summary-navigation {
    grid-column: 1 / -1;
    flex-direction: row;
    min-width: 0;
  }

  .summary-navigation .summary-button {
    flex: 1 1;
  }
}

/* ==========================================
   Tablets
========================================== */

@media (max-width: 900px) {
  .summary-card {
    width: calc(100% - 28px);
    padding: 22px;
  }

  .summary-content {
    grid-template-columns: 1fr 1fr;
  }

  .summary-map-tile {
    grid-column: 1 / -1;
  }

  .summary-navigation {
    grid-column: 1 / -1;
    flex-direction: row;
    min-width: 0;
  }

  .summary-button {
    flex: 1 1;
  }
}

/* ==========================================
   Phones
========================================== */

@media (max-width: 600px) {
  .summary-card {
    width: calc(100% - 20px);
    margin: 16px auto;
    padding: 18px;

    border-left-width: 4px;
    border-radius: 14px;
  }

  .summary-card-header {
    flex-direction: column;
    gap: 12px;

    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  .summary-period {
    align-self: flex-start;
  }

  .summary-content {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .summary-stat,
  .summary-map-tile,
  .summary-navigation {
    grid-column: auto;
  }

  .summary-stat {
    padding: 16px;
  }

  .summary-stat strong {
    font-size: 1.75rem;
  }

  .summary-map-header {
    align-items: stretch;
    flex-direction: column;
  }

  .summary-map-button {
    width: 100%;
  }

  .summary-map-container {
    height: 230px;
  }

  .summary-navigation {
    flex-direction: column;
  }

  .summary-button {
    width: 100%;
  }
}

/* ==========================================
   Very small phones
========================================== */

@media (max-width: 400px) {
  .summary-card {
    width: calc(100% - 12px);
    padding: 14px;
  }

  .summary-card-header h2 {
    font-size: 1.25rem;
  }

  .summary-period {
    font-size: 0.78rem;
  }

  .summary-stat {
    padding: 14px;
  }

  .summary-map-container {
    height: 210px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SummaryBar/SummaryBar.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;;EAElB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;;EAEnB;;sCAEoC;;EAEpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;;EAET,oBAAoB;EACpB,mBAAmB;;EAEnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;;EAElB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;;EAET,cAAc;EACd,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;;EAEjB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;;EAEpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;;EAElB,sBAAsB;AACxB;;AAEA;;4CAE4C;;AAE5C;EACE,aAAa;EACb;;;;yBAIuB;;EAEvB,SAAS;EACT,oBAAoB;EACpB,YAAY;AACd;;AAEA;;4CAE4C;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;;EAEnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;;EAEf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;;EAEf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;4CAE4C;;AAE5C;EACE,YAAY;EACZ,gBAAgB;;EAEhB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;;EAEnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;;EAET,mBAAmB;EACnB,gCAAgC;;EAEhC,sBAAsB;AACxB;;AAEA;EACE,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;;EAEjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;EAElB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,eAAe;;EAEf;;;wBAGsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;;EAEb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;;EAEV,aAAa;;EAEb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;4CAE4C;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;;EAET,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;;EAEhB,eAAe;;EAEf;;;;wBAIsB;;EAEtB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;4CAE4C;;AAE5C;EACE;IACE;+BAC2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;;4CAE4C;;AAE5C;EACE;IACE,wBAAwB;IACxB,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;;4CAE4C;;AAE5C;EACE;IACE,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;;IAEb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;;IAET,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;4CAE4C;;AAE5C;EACE;IACE,wBAAwB;IACxB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".summary-card {\n  width: min(1400px, calc(100% - 40px));\n  margin: 28px auto;\n  padding: 24px 28px;\n\n  background: #ffffff;\n  border: 1px solid #d9e2dc;\n  border-left: 6px solid #277a3e;\n  border-radius: 18px;\n\n  box-shadow:\n    0 1px 2px rgba(23, 33, 26, 0.05),\n    0 10px 28px rgba(23, 33, 26, 0.08);\n\n  box-sizing: border-box;\n}\n\n.summary-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n\n  border-bottom: 1px solid #d9e2dc;\n}\n\n.summary-eyebrow {\n  display: block;\n  margin-bottom: 5px;\n\n  color: #277a3e;\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.summary-card-header h2 {\n  margin: 0;\n\n  color: #17211a;\n  font-size: clamp(1.25rem, 2vw, 1.65rem);\n  line-height: 1.2;\n}\n\n.summary-period {\n  flex-shrink: 0;\n  max-width: 100%;\n  padding: 8px 14px;\n\n  background: #fff8cc;\n  border: 1px solid #ebd650;\n  border-radius: 999px;\n\n  color: #665700;\n  font-size: 0.86rem;\n  font-weight: 700;\n  line-height: 1.3;\n  text-align: center;\n\n  box-sizing: border-box;\n}\n\n/* ==========================================\n   Summary content layout\n========================================== */\n\n.summary-content {\n  display: grid;\n  grid-template-columns:\n    minmax(180px, 0.85fr)\n    minmax(180px, 0.85fr)\n    minmax(280px, 1.2fr)\n    minmax(170px, 0.45fr);\n\n  gap: 18px;\n  align-items: stretch;\n  min-width: 0;\n}\n\n/* ==========================================\n   AC and DC statistic tiles\n========================================== */\n\n.summary-stat {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  min-width: 0;\n  padding: 18px 20px;\n  border-radius: 14px;\n\n  box-sizing: border-box;\n}\n\n.summary-stat-ac {\n  background: #eaf4ed;\n  border: 1px solid #b7d8bf;\n}\n\n.summary-stat-dc {\n  background: #fff8cc;\n  border: 1px solid #ebd650;\n}\n\n.summary-stat-label {\n  color: #526159;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.summary-stat strong {\n  margin-top: 6px;\n\n  color: #17211a;\n  font-size: 2rem;\n  line-height: 1.1;\n}\n\n.summary-stat strong span {\n  color: #617067;\n  font-size: 1.1rem;\n  font-weight: 650;\n}\n\n.summary-stat small {\n  margin-top: 6px;\n\n  color: #617067;\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n/* ==========================================\n   Compact map tile\n========================================== */\n\n.summary-map-tile {\n  min-width: 0;\n  overflow: hidden;\n\n  background: #ffffff;\n  border: 1px solid #c8d9ce;\n  border-radius: 14px;\n\n  box-sizing: border-box;\n}\n\n.summary-map-header {\n  min-height: 66px;\n  padding: 11px 13px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  background: #f7faf7;\n  border-bottom: 1px solid #d9e2dc;\n\n  box-sizing: border-box;\n}\n\n.summary-map-header > div {\n  min-width: 0;\n\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.summary-map-label {\n  color: #4e6255;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.summary-map-header strong {\n  color: #17211a;\n  font-size: 0.96rem;\n  line-height: 1.25;\n}\n\n.summary-map-button {\n  flex-shrink: 0;\n  padding: 8px 10px;\n\n  background: #ffffff;\n  border: 1px solid #79ae88;\n  border-radius: 9px;\n\n  color: #17552a;\n  font-family: inherit;\n  font-size: 0.74rem;\n  font-weight: 750;\n  white-space: nowrap;\n\n  cursor: pointer;\n\n  transition:\n    background 150ms ease,\n    border-color 150ms ease,\n    transform 150ms ease;\n}\n\n.summary-map-button:hover {\n  background: #eaf4ed;\n  border-color: #277a3e;\n  transform: translateY(-1px);\n}\n\n.summary-map-button:focus-visible {\n  outline: 3px solid rgba(39, 122, 62, 0.22);\n  outline-offset: 2px;\n}\n\n.summary-map-container {\n  position: relative;\n  width: 100%;\n  height: 170px;\n\n  overflow: hidden;\n  background: #edf2ee;\n}\n\n.summary-leaflet-map {\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.summary-map-empty {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n\n  padding: 18px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: rgba(247, 250, 247, 0.94);\n  color: #617067;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.summary-map-tile .leaflet-popup-content {\n  min-width: 160px;\n  margin: 12px 14px;\n}\n\n.summary-map-tile .leaflet-popup-content p {\n  margin: 5px 0;\n\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.summary-map-tile .leaflet-popup-content a {\n  color: #277a3e;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n/* ==========================================\n   Month navigation\n========================================== */\n\n.summary-navigation {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n\n  min-width: 170px;\n}\n\n.summary-button {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 16px;\n\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n\n  cursor: pointer;\n\n  transition:\n    background 150ms ease,\n    border-color 150ms ease,\n    color 150ms ease,\n    transform 150ms ease;\n\n  box-sizing: border-box;\n}\n\n.summary-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.summary-button-primary {\n  color: #ffffff;\n  background: #277a3e;\n  border: 1px solid #277a3e;\n}\n\n.summary-button-primary:hover:not(:disabled) {\n  background: #17552a;\n  border-color: #17552a;\n}\n\n.summary-button-secondary {\n  color: #17552a;\n  background: #ffffff;\n  border: 1px solid #9fc5a8;\n}\n\n.summary-button-secondary:hover:not(:disabled) {\n  background: #eaf4ed;\n  border-color: #277a3e;\n}\n\n.summary-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ==========================================\n   Smaller desktop and large tablets\n========================================== */\n\n@media (max-width: 1200px) {\n  .summary-content {\n    grid-template-columns:\n      repeat(2, minmax(0, 1fr));\n  }\n\n  .summary-map-tile {\n    grid-column: 1 / -1;\n  }\n\n  .summary-map-container {\n    height: 220px;\n  }\n\n  .summary-navigation {\n    grid-column: 1 / -1;\n    flex-direction: row;\n    min-width: 0;\n  }\n\n  .summary-navigation .summary-button {\n    flex: 1;\n  }\n}\n\n/* ==========================================\n   Tablets\n========================================== */\n\n@media (max-width: 900px) {\n  .summary-card {\n    width: calc(100% - 28px);\n    padding: 22px;\n  }\n\n  .summary-content {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .summary-map-tile {\n    grid-column: 1 / -1;\n  }\n\n  .summary-navigation {\n    grid-column: 1 / -1;\n    flex-direction: row;\n    min-width: 0;\n  }\n\n  .summary-button {\n    flex: 1;\n  }\n}\n\n/* ==========================================\n   Phones\n========================================== */\n\n@media (max-width: 600px) {\n  .summary-card {\n    width: calc(100% - 20px);\n    margin: 16px auto;\n    padding: 18px;\n\n    border-left-width: 4px;\n    border-radius: 14px;\n  }\n\n  .summary-card-header {\n    flex-direction: column;\n    gap: 12px;\n\n    padding-bottom: 16px;\n    margin-bottom: 16px;\n  }\n\n  .summary-period {\n    align-self: flex-start;\n  }\n\n  .summary-content {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n\n  .summary-stat,\n  .summary-map-tile,\n  .summary-navigation {\n    grid-column: auto;\n  }\n\n  .summary-stat {\n    padding: 16px;\n  }\n\n  .summary-stat strong {\n    font-size: 1.75rem;\n  }\n\n  .summary-map-header {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .summary-map-button {\n    width: 100%;\n  }\n\n  .summary-map-container {\n    height: 230px;\n  }\n\n  .summary-navigation {\n    flex-direction: column;\n  }\n\n  .summary-button {\n    width: 100%;\n  }\n}\n\n/* ==========================================\n   Very small phones\n========================================== */\n\n@media (max-width: 400px) {\n  .summary-card {\n    width: calc(100% - 12px);\n    padding: 14px;\n  }\n\n  .summary-card-header h2 {\n    font-size: 1.25rem;\n  }\n\n  .summary-period {\n    font-size: 0.78rem;\n  }\n\n  .summary-stat {\n    padding: 14px;\n  }\n\n  .summary-map-container {\n    height: 210px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
